import { messageForConnectionType } from '@tableau/catalog-ui-temp';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';
import { MarkupField } from '~src/spacesPlatform/components/Explorer/widgets/MarkupField';
import { getCommonDatabaseInfo } from '~src/spacesPlatform/models/CommonDatabaseInfo';
import { Tags } from '~src/tags/components/tooltips/Tags';

import { BasicField } from './BasicField';
import { Name } from './Name';
import { Tooltip } from './Tooltip';
import { ContentTooltipProps, TooltipDescriptionTestId } from './TooltipHelper';

export function DatabaseTooltip(props: ContentTooltipProps): JSX.Element {
    const content = props.content;
    const tags = getTags(props.content.tags);
    const commonDatabase = getCommonDatabaseInfo(content);
    const isDbServer: boolean = commonDatabase.dbType === 'DatabaseServer';

    return (
      <Tooltip>
        <Name name={content.name} url={props.contentUrl}/>
        <MarkupField markup={content.description}
                     testId={TooltipDescriptionTestId}
                     extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]}/>
        <dl className={DetailsTooltipStyles.DescriptionList}>
          <Tags tags={tags}/>
          <BasicField name={isDbServer ? Messages.databaseTooltipConnectionType() : Messages.databaseTooltipFileType()}
                      value={messageForConnectionType(commonDatabase.connectionType)}/>
          <BasicField name={isDbServer ? Messages.databaseTooltipHostname() : Messages.databaseTooltipFilePath()}
                      value={commonDatabase.hostName}/>
          <BasicField value={commonDatabase.contactName} name={Messages.databaseTooltipContact()}/>
        </dl>
      </Tooltip>
);
}

function getTags(contentTags: any) {
  if (contentTags.length > 0) {
      if(typeof contentTags[0] === 'object') {
          return contentTags.map((tag: {name: any}) => { return tag.name;});
      }
  }
  return contentTags;
}